import { combineReducers } from 'redux'

import { routerReducer } from 'react-router-redux'

import clients from 'scenes/Clients/reducer'
import passwordRecovery from 'scenes/PasswordRecovery/reducer'
import newClient from 'scenes/NewClient/reducer'
import clientDetail from 'scenes/ClientDetail/reducer'
import vehicleDetail from 'scenes/VehicleDetail/reducer'
import policyVehicleDetail from 'scenes/VehicleDetail/components/Policy/reducer'
import dataVehicleDetail from 'scenes/VehicleDetail/components/Data/reducer'
import driversVehicleDetail from 'scenes/VehicleDetail/components/Drivers/reducer'
import addVehicleModal from 'scenes/ClientDetail/components/AddVehicleModal/reducer'
import selectWorkshop from 'scenes/VehicleDetail/components/ClaimData/Workshop/reducer'

import claims from 'scenes/Claims/reducer'
import claimNotification from 'scenes/VehicleDetail/components/Claim/Notifications/reducer'
import claimNotes from 'scenes/VehicleDetail/components/Claim/Notes/reducer'

import policyForm from 'components/PolicyForm/reducer'
import driversForm from 'components/DriversForm/reducer'
import requestStatus from 'components/RequestStatus/reducer'

import user from 'reducers/global/user'

export default function createReducer() {
  return combineReducers({
    passwordRecovery,
    requestStatus,
    clients,
    newClient,
    clientDetail,
    addVehicleModal,
    user,
    claims,
    vehicleDetail,
    policyVehicleDetail,
    dataVehicleDetail,
    driversVehicleDetail,
    policyForm,
    driversForm,
    selectWorkshop,
    claimNotification,
    claimNotes,
    routing: routerReducer
  })
}



// WEBPACK FOOTER //
// ./src/reducers/index.js